import classNames from "classnames";
import styles from "./ListFilter.module.scss";
import { Button } from "@mui/material";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import ClearIcon from "@mui/icons-material/Clear";

const ListFilter = ({ className, children, showClearButton = true }) => {
  const { resetFilter } = useFilterAndPagination();
  return (
    <div className={classNames(styles["list-filter"], className)}>
      <div className={styles["list-filter__header"]}>
        <p className={styles["title"]}>Filters</p>
        {showClearButton && (
          <Button
            size="small"
            className={styles["clear-filter"]}
            onClick={() => resetFilter()}
            endIcon={<ClearIcon />}
          >
            Clear filters
          </Button>
        )}
      </div>
      <div className={styles["list-filter__content"]}>{children}</div>
    </div>
  );
};

export default ListFilter;
